import React, { useEffect, useRef } from "react";
import MultiSelect from "../common/TextField/dropDown";
import { useDispatch, useSelector } from "react-redux";
import { setCreationValue, setResetDropdown } from "./slice";
import { fetchDepsUnits } from "../Login/action";
import useConfiguration from "../../hooks/useConfiguration";
import DropDown from "../common/SearchableSelect";

const DepsUnits = (props) => {
    const dispatch = useDispatch();
    const depsUnitsRef = useRef();
    const depsUnitsMaster = useSelector(store => store.login.depsUnitsMaster);
    const depsUnits = useSelector(store => store.jobOpportunity.depsUnits);
    const resetDropdown = useSelector(store => store.jobOpportunity.resetDropdown);
    const selectedOption = useSelector(store => store.jobOpportunity.selectedOption);
    const {newPost,fromTemplate,createTemplate,editJobPost} = selectedOption
    // const depsUnitsChangeHandler = e => {
    //     const {action,value,name} = e;
    //     let copyDepsUnits = [...depsUnits];
    //     if(action === "add"){
    //         copyDepsUnits.push(value)
    //     } else if(action === "remove"){
    //         copyDepsUnits = copyDepsUnits?.filter(item => item?.id !== value?.id)
    //     }
    //     dispatch(setCreationValue({name,value:copyDepsUnits}))
    // }

    const depsUnitsChangeHandler = (target) => {
      const value = target.value;
      dispatch(setCreationValue({ field: "depsUnits", value }));
    };

    // useEffect(() => {
    //   if(config.baseUrl && depsUnitsMaster?.length ===0){
    //     dispatch(fetchDepsUnits({baseUrl:config.baseUrl}))
    //   }
    // },[config])
  //   useEffect(() => {
  //     if(newPost|| fromTemplate || createTemplate ){
  //         if(resetDropdown){
  //           depsUnitsRef.current.resetSelectedValues();
  //             dispatch(setResetDropdown(false))
  //         }
  //     }
     
  // },[newPost,fromTemplate,createTemplate,editJobPost,resetDropdown]) 
  return (
    <div className="card">
      <div className="col-lg-12 col-md-12">
        <div className="row">
          <div className="card-header">
            <h3 class="card-title">Departments<span class="required">*</span></h3>
          </div>
          <div className="card-body">
            <div className="row">
              {/* <MultiSelect
                divClass={"w-100"}
                name={"depsUnits"}
                id={'depsUnits'}
                value={depsUnits}
                options={depsUnitsMaster}
                multiple={true}
                updateValue={depsUnitsChangeHandler}
                isObject={true}
                errors={props.errors ? props.errors["depsUnits"] : []}
                multiselectRef={depsUnitsRef}
              /> */}

                                <DropDown
                                  name={"depsUnits"}
                                  // placeholder={"Select"}
                                  options={depsUnitsMaster}
                                  multiple={false}
                                  value={
                                    depsUnits
                                      ? [depsUnits]
                                      : []
                                  }
                                  updateValue={depsUnitsChangeHandler}
                                  isObject={true}
                                  showArrow={true}
                                  divClass={"me-1 mx-1"}
                                  multiselectRef={depsUnitsRef}
                                  errors={props.errors ? props.errors["depsUnits"] : []}
                                />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepsUnits;
